import { TOGGLE_COMPLIANCE_STATUS_VIEW, TOGGLE_COMPLIANCE_DATE_VIEW, SET_COMPLIANCE_PERCENTAGE, SET_COMPLIANCE_DEFAULT_LOAD } from './actionTypes'

export const setComplianceStatusView = (status) => {
    console.log("Action :", status)
    return {
        type : TOGGLE_COMPLIANCE_STATUS_VIEW,
        info : "Comp status view redux action :",
        status : status
    }
}

export const setComplianceDateView = (transpose) => {
    console.log("Action :", transpose)
    return {
        type : TOGGLE_COMPLIANCE_DATE_VIEW,
        info : "Comp date view redux action :",
        transpose : transpose
    }
}

export const setCompliancePercentage = (compliancePercentage) => {
    console.log("Action :", compliancePercentage)
    return {
        type : SET_COMPLIANCE_PERCENTAGE,
        info : "Comp range redux action :",
        complianceRange : compliancePercentage
    }
}

export const setDefaultLoad = (defaultLoad) => {
    // console.log("Action :", defaultLoad)
    return {
        type : SET_COMPLIANCE_DEFAULT_LOAD,
        info : "Comp hotel default load redux action :",
        defaultLoad : defaultLoad
    }
}

// export const setCustomTabView = (customTabView) => {
//     return {
//         type : SET_COMPLIANCE_CUSTOM_TAB_VIEW,
//         info : "Comp custometab view type redux action :",
//         customTabView : customTabView
//     }
// }